<template>
  <div>
    <div
        ref="scrollToPoint">
    </div>
    <div
        id="media-manager"
        aria-hidden="true"
        aria-labelledby="media-manager"
        class="modal"
        data-backdrop="fixed"
        data-keyboard="false"
        role="dialog"
        tabindex="-1"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="block block-themed block-transparent mb-0">
            <div class="block-header bg-primary-dark">
              <h3 class="block-title">Manage Media</h3>
              <div class="block-options">
                <button
                    aria-label="Close"
                    class="btn-block-option"
                    data-dismiss="modal"
                    type="button"
                >
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <div id="block-content" class="block-content">
              <div v-show="!draggingFiles">

                <form
                    id="new-file-form"
                    action="#"
                    method="#"
                    @submit.prevent="submitForm"
                >
                  <div class="d-flex justify-content-end mb-2">
                    <button :disabled="loading.cloudinary" class="btn btn-success pa-3 me-2"
                            @click.prevent="uploadContent">
                       <span class="file-icon mr-2">
                         <i class="fa fa-upload"></i>
                      </span>
                      Upload File(s)
                      <i v-if="loading.cloudinary" class="fa fa-fw fa-circle-notch fa-spin ms-2"></i>
                    </button>
                  </div>
                  <div class="d-flex full-width">
                    <div class="flex-grow-1 input-group has-feedback has-clear mr-2">
                      <input
                          v-model="searchText"
                          class="js-icon-search form-control font-size-base"
                          placeholder="Search..."
                          type="text"
                      />
                      <span
                          v-if="searchText && searchText.length"
                          class="form-control-clear fa fa-times form-control-feedback"
                          @click="clearSearchText()"
                      ></span>
                      <div class="input-group-append">
											  	<span class="input-group-text">
													<i class="fa fa-search"></i>
											  	</span>
                      </div>
                    </div>
                  </div>
                </form>

                <div v-if="uploadProgress > 0" class="progress push mt-1"
                     style="height: 10px;">
                  <div
                      :aria-valuenow="uploadProgress"
                      :style="'width: '+uploadProgress+'%;'"
                      aria-valuemax="100"
                      aria-valuemin="0"
                      class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                      role="progressbar"
                  ></div>
                </div>

                <div class="container is-fluid box">
                  <div class="bg-body-light mt-2">
                    <!-- Navigation -->
                    <div v-if="navSearch && isAdmin">
                      <ol
                          class="nav-main nav-main-horizontal nav-main-hover breadcrumb breadcrumb-alt"
                      >
                        <li class="nav-main-item breadcrumb-item nav-breadcrumb">
                          <a class="nav-main-link active" @click.prevent="navChanged()">
                            <span class="nav-main-link-name">Partner</span>
                          </a>
                        </li>
                        <li class="nav-main-item breadcrumb-item nav-breadcrumb">
                          <a
                              aria-expanded="false"
                              aria-haspopup="true"
                              class="nav-main-link nav-main-link-submenu"
                              data-toggle="submenu"
                              href="#"
                          >
                            <span class="nav-main-link-name">{{ navSearch.entity }}</span>
                          </a>
                          <ul class="nav-main-submenu">
                            <li v-for="entity of navEntities" class="nav-main-item">
                              <a class="nav-main-link"
                                 @click.prevent="navChanged(entity)">
                                <span class="nav-main-link-name">{{ entity }}</span>
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li
                            v-if="navSearch.entity && navSearch.entity != 'All'"
                            class="nav-main-item breadcrumb-item nav-breadcrumb"
                        >
                          <a
                              aria-expanded="false"
                              aria-haspopup="true"
                              class="nav-main-link nav-main-link-submenu"
                              data-toggle="submenu"
                              href="#"
                          >
                            <span class="nav-main-link-name">
                              {{ navSearch.itemName }}
                            </span>
                          </a>
                          <ul v-if="navSearch.entity === 'Campaigns'"
                              class="nav-main-submenu">
                            <li class="nav-main-item">
                              <a class="nav-main-link"
                                 @click.prevent="navChanged(navSearch.entity)">
                                <span class="nav-main-link-name">All</span>
                              </a>
                            </li>
                            <li v-for="campaign in campaigns" class="nav-main-item">
                              <a
                                  class="nav-main-link"
                                  @click.prevent="navChanged(navSearch.entity, campaign.id)"
                              >
                                <span class="nav-main-link-name">
                                  {{ campaign.name }}
                                </span>
                              </a>
                            </li>
                          </ul>
                          <ul v-if="navSearch.entity === 'Venues'"
                              class="nav-main-submenu">
                            <li class="nav-main-item">
                              <a class="nav-main-link"
                                 @click.prevent="navChanged(navSearch.entity)">
                                <span class="nav-main-link-name">All</span>
                              </a>
                            </li>
                            <li v-for="venue in venues" class="nav-main-item">
                              <a
                                  class="nav-main-link"
                                  @click.prevent="navChanged(navSearch.entity, venue.id)"
                              >
                                <span class="nav-main-link-name">{{ venue.name }}</span>
                              </a>
                            </li>
                          </ul>
                          <ul v-else-if="navSearch.entity === 'Products'"
                              class="nav-main-submenu">
                            <li class="nav-main-item">
                              <a class="nav-main-link"
                                 @click.prevent="navChanged(navSearch.entity)">
                                <span class="nav-main-link-name">All</span>
                              </a>
                            </li>
                            <li v-for="product in products" class="nav-main-item">
                              <a
                                  class="nav-main-link"
                                  @click.prevent="navChanged(navSearch.entity, product.id)"
                              >
                                <span class="nav-main-link-name">{{ product.name }}</span>
                              </a>
                            </li>
                          </ul>
                          <ul v-else-if="navSearch.entity === 'Deals'"
                              class="nav-main-submenu">
                            <li class="nav-main-item">
                              <a class="nav-main-link"
                                 @click.prevent="navChanged(navSearch.entity)">
                                <span class="nav-main-link-name">All</span>
                              </a>
                            </li>
                            <li v-for="deal in deals" class="nav-main-item">
                              <a
                                  class="nav-main-link"
                                  @click.prevent="navChanged(navSearch.entity, deal.id)"
                              >
                                <span class="nav-main-link-name">{{ deal.name }}</span>
                              </a>
                            </li>
                          </ul>
                          <ul v-else-if="navSearch.entity === 'Packages'"
                              class="nav-main-submenu">
                            <li class="nav-main-item">
                              <a class="nav-main-link"
                                 @click.prevent="navChanged(navSearch.entity)">
                                <span class="nav-main-link-name">All</span>
                              </a>
                            </li>
                            <li v-for="p in packages" class="nav-main-item">
                              <a
                                  class="nav-main-link"
                                  @click.prevent="navChanged(navSearch.entity, p.id)"
                              >
                                <span class="nav-main-link-name">{{ p.name }}</span>
                              </a>
                            </li>
                          </ul>
                          <ul v-else class="nav-main-submenu">
                            <li class="nav-main-item">
                              <a class="nav-main-link"
                                 @click.prevent="navChanged(navSearch.entity)">
                                <span class="nav-main-link-name">All</span>
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ol>
                    </div>
                    <!-- END Navigation -->
                  </div>

                  <div class="d-flex tabs is-centered is-large full-width text-center">
                    <ul
                        class="nav nav-tabs-alt nav-tabs-block m-auto"
                        data-toggle="tabs"
                        role="tablist"
                    >
                      <li class="nav-item">
                        <a
                            :class="{'is-active active': checkActiveTabs('image'), 'disabled': enableTabs.indexOf('image') === -1}"
                            class="nav-link"
                            href="#"
                            @click.prevent="getFiles('image')"
                        >
                        <span class="icon is-small">
                          <i class="fa fa-image"></i>
                        </span> Pictures
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                            :class="{'is-active active': checkActiveTabs('audio'), 'disabled': enableTabs.indexOf('audio') === -1}"
                            class="nav-link"
                            href="#"
                            @click.prevent="getFiles('audio')"
                        >
                        <span class="icon is-small">
                          <i class="fa fa-music"></i>
                        </span> Music
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                            :class="{'is-active active': checkActiveTabs('video'), 'disabled': enableTabs.indexOf('video') === -1}"
                            class="nav-link"
                            href="#"
                            @click.prevent="getFiles('video')"
                        >
                        <span class="icon is-small">
                          <i class="fa fa-film"></i>
                        </span> Videos
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                            :class="{'is-active active': checkActiveTabs('document'), 'disabled': enableTabs.indexOf('document') === -1}"
                            class="nav-link"
                            href="#"
                            @click.prevent="getFiles('document')"
                        >
                          <span class="icon is-small">
                            <i class="fa fa-file-alt"></i>
                          </span>
                          Documents
                        </a>
                      </li>
                    </ul>
                  </div>
                  <hr/>

                  <div class="tabs-details pr-3 pt-3 pl-3 pb-1 bg-body-light">
                    <div class="row gutters-tiny">
                      <div
                          v-cloak
                          v-if="pagination.total == 0"
                          class="is-empty column is-4 is-offset-4"
                      >
                        <div class="text-center">
                          <p class="title is-2 text-warning">This folder is empty!</p>
                        </div>
                      </div>

                      <div v-if="loading.loading" class="loading column is-4 is-offset-4">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only w30">Loading...</span>
                      </div>
                      <div
                          v-for="file in files"
                          v-cloak
                          v-else
                          :class="{ 'col-sm-4': activeTab == 'audio', 'col-sm-3': activeTab == 'video', 'col-sm-2': activeTab != 'video', 'file-selected': chosenFile == file}"
                          class="col mb-2"
                      >
                        <a class href="javascript:void(0)" @click="chosenFile = file">
                          <div
                              :class="activeTab == 'image' ? 'is-image' : ''"
                              class="card d-flex flex-column h-100 block block-bordered block-rounded block-link-shadow p-0"
                          >
                            <div class="card-image flex-grow-1">
                              <div class="full-width pull-right card-button">
                                <button
                                    :class="'delete delete-file mr-1 '+(file.usageCount ? 'text-muted' : 'text-danger')"
                                    :disabled="!!file.usageCount"
                                    :title="file.usageCount ? 'This is being used and cannot be removed' : 'Remove'"
                                    @click.prevent="prepareToDelete(file)"><i
                                    class="fa fa-times-circle"></i></button>
                              </div>

                              <figure v-if="activeTab == 'image'" class="image is-4by3">
                                <img :alt="file.name" :src="file.url"/>
                              </figure>

                              <div v-if="activeTab == 'audio'" class="audio">
                                <audio controls>
                                  <source :src="`https://res.cloudinary.com/bandwango/video/upload/${file.host_id}.mp4`"
                                          type="audio/mpeg"/>
                                  Your browser does not support the audio tag.
                                </audio>
                              </div>

                              <div v-if="activeTab == 'video'" class="video_block img-fluid">
                                <cld-video
                                    :key="file.host_id"
                                    :public-id="file.host_id"
                                    cloudName="bandwango"
                                    height="150"
                                    secure="true"
                                    width="100%"
                                />
                                <a
                                    :href="`https://res.cloudinary.com/bandwango/video/upload/${file.host_id}.mp4`"
                                    class="pl-3"
                                    target="_blank"
                                >
                                  <button class="btn btn-success btn-sm">See Preview</button>
                                </a>
                              </div>

                              <div v-if="activeTab == 'document'" class="document_block">
                                <a :href="file.url" class="button is-primary"
                                   target="_blank">
                                  <i aria-hidden="true" class="fa fa-download"></i>
                                  &nbsp;Download
                                </a>
                              </div>
                            </div>
                            <div class="card-details mt-auto p-3 font-size-sm">
                              <div>
                                <div>{{ file.original_file_name | truncate(20) }}</div>
                                <div class="d-flex">
                                  <div>
                                    <time datetime="2016-1-1">{{ file.created_at }}
                                    </time>
                                  </div>
                                  <div>
                                    <input
                                        id="chosen-file"
                                        :checked="chosenFile == file"
                                        class="custom-control-input"
                                        name="chosen-file"
                                        type="checkbox"
                                        @click="chosenFile = file"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div v-if="pagination.total">
                    <bw-pagination
                        :offset="4"
                        :pagination="pagination"
                        style="margin-left: 20px;"
                        @paginate="changePage"
                    ></bw-pagination>
                  </div>

                </div>
              </div>
              <div v-show="draggingFiles" id="dropzone" class="dropzone">
                <div class="dz-message" data-dz-message>
                  <span>Drop file(s) here</span>
                </div>
              </div>
            </div>
            <div class="block-content block-content-full text-right border-top">
              <button class="btn btn-sm btn-light" data-dismiss="modal" type="button"
                      @click="resetForm()">Cancel
              </button>
              <button
                  v-if="chosenFile && chosenFile.url"
                  class="btn btn-sm btn-success"
                  @click.prevent="selectImage"
              >Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

import $api from '@api/api'
import BwPagination from '@components/shared/BwPagination';

export default {
  components: {
    BwPagination,
  },
  props: {
    entity: Number | String,
    entityId: Number | String,
    timezone: String,
    partnerId: Number,
    website: String,
    facebook: String,
    isAdmin: {
      type: Boolean,
      default: true,
    },
    superAdmin: Boolean,
    navSearch: {
      type: Object,
      default: function () {
        return { entity: "image", itemId: 0, itemName: "image" };
      },
    },
    showTab: {
      type: String | Array,
      default: function () {
        return ['image']
      }
    },
    enableTabs: {
      type: String | Array,
      default: function () {
        return 'image'
      }
    },
  },
  data() {
    return {
      chosenFile: {},
      files: [],
      campaigns: [],
      products: [],
      venues: [],
      deals: [],
      packages: [],
      attachment: {},
      pagination: {
        per_page: 12,
        current_page: 1,
        total: 0,
      },
      activeTab: 'All',
      offset: 5,
      navEntities: ["All", "Campaigns", "Deals", "Offers", "Packages", "Products", "Venues"],
      fileSrc: "Bandwango",
      fileName: "",
      loading: {
        loading: false,
        cloudinary: false
      },
      moment: require("moment"),
      uploadProgress: 0,
      searchText: "",
      searchTimeout: null,
      draggingFiles: false,
      success_msg: "",
      error_msg: "",
      lastParams: {},
    };
  },

  methods: {

    checkActiveTabs(tabName) {
      return !!this.showTab.includes(tabName)
    },

    uploadContent() {
      this.loading.cloudinary = true;
      window.cloudinary.openUploadWidget(
          {
            cloud_name: 'Bandwango',
            upload_preset: 'Partner Files',
            folder: `partners/${this.entity}/${this.entityId}`,
            maxFileSize: 1073741824, //1GB,
            sources: ['local', 'instagram', 'facebook', 'dropbox', 'unsplash', 'google_drive', 'shutterstock'],
            showPoweredBy: false,
            buttonClass: 'cloudinary-button',
            buttonCaption: 'Up'
          },
          (error, result) => {
            if (!error && result && result.event === "success") {
              this.uploadCloudinaryFile(result.info)
            }
            this.loading.cloudinary = false;
          }).open();

    },

    async uploadCloudinaryFile(file) {
      try {
        file = {
          ...file,
          'upload_assignment': this.entity || 0,
          'upload_assignment_id': this.entityId || 0,
        }

        await axios.post(`/cloudMedia`, file)

        // this function refetches the files
        this.fetchFile(this.activeTab, this.navSearch);
      } catch (error) {
        console.error(`Failed to send out file: ${file}`, error)
      }
    },

    clearSearchText() {
      this.searchText = "";
      this.pagination.current_page = 1;
      this.fetchFile(this.activeTab);
    },
    importFile() {
      const files = this.fileName.split(',').map(x => x && x.trim()).filter(x => !!x);
      this.addMedia(files);
    },
    addMedia(files = false) {
      if (!files) files = this.$refs.file.files;

      this.formData = new FormData();
      files.forEach((f) => {
        this.formData.append("files[]", f);
      });

      let url = "/medias?";
      if (this.superAdmin) url = "/superAdmin/addMedia?";

      if (this.navSearch.entity && this.navSearch.entity != "All") {
        let entity = this.navSearch.entity.substring(
            0,
            this.navSearch.entity.length - 1
        );
        this.formData.append("uploadAssignment", entity.toLowerCase());
      }
      if (this.navSearch.itemId)
        this.formData.append("uploadAssignmentId", this.navSearch.itemId);

      if (this.navSearch.partner_id)
        url += "partnerId=" + this.navSearch.partner_id + "&";

      this.uploadProgress = 1;

      axios
          .post(url, this.formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.floor(
                  (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          })
          .then((response) => {
            response.data.forEach((media) => {
              this.scaleDownImage(media);
              this.files.unshift(media);
              if (this.files.length > this.pagination.per_page) this.files.pop(); // push the last items back a page

              // auto choose the first image
              this.chosenFile = this.files[0];

              this.$forceUpdate();
            });
            // this.files = [...this.files, ...response.data];
            this.pagination.total = this.files.length; // should we just requery files?
            this.success_msg = "Image(s) uploaded successfully.";
            // this.chosenFile = this.files[this.files.length-1];
            this.resetForm();
          })
          .catch((error) => {
            this.uploadProgress = 0;
            this.error_msg = (error.response && error.response.data && error.response.data.error_msg) ||
                "Error uploading media.";
          });
    },
    navChanged(entity = "image", itemId = 0) {
      this.navSearch.entity = entity;
      this.navSearch.itemId = itemId > 0 ? itemId : 0;

      if (this.navSearch && this.navSearch.itemId) {
        if (
            ["Deals", "Packages", "Products", "Venues"].indexOf(
                this.navSearch.entity
            ) > -1
        ) {
          const f = this[this.navSearch.entity.toLowerCase()].find(
              (x) => x.id === this.navSearch.itemId
          );
          if (f) {
            this.navSearch.itemName = f.name;
            this.navSearch.partner_id = f.partner_id;
          }
        }
      } else {
        this.navSearch.itemName = "All";
      }

      if (!this.navSearch.itemName) {
        this.navSearch.itemName = "All";
      }

      // reset the page to 1 if navigation changed
      this.pagination.current_page = 1;

      this.files = [];
      this.fetchFile(this.activeTab, this.navSearch);
    },
    async fetchFile(type, params = {}) {
      if (!this.isAdmin && !this.navSearch.entity && !this.navSearch.itemId) {
        this.files = [];
        return;
      }

      this.loading.loading = true;

      let page = 1;
      if (this.pagination && this.pagination.current_page > 1) {
        page = this.pagination.current_page;
      }

      const d = {
        type,
        display: this.pagination.per_page,
        page,
        searchText: this.searchText,
      };

      if (!_.isEmpty(params) || !_.isEmpty(this.lastParams)) {
        params = _.extend({}, this.lastParams, params);
        if (params.entity && params.entity != "All") {
          d.uploadAssignment = params.entity.toLowerCase();
          if (d.uploadAssignment.substring(d.uploadAssignment.length - 1, d.uploadAssignment.length) === "s")
            d.uploadAssignment = d.uploadAssignment.substring(0, d.uploadAssignment.length - 1);
        }
        if (params.itemId) {
          d.uploadAssignmentId = params.itemId;
        }
        this.lastParams = JSON.parse(JSON.stringify(params));
      }

      if (this.fileSrc == "Website" || this.fileSrc == "Facebook") {
        if (this.fileSrc == "Facebook")
          d.fromWebsite = "https://www.facebook.com/visitiowa";
        else d.fromWebsite = "https://www.traveliowa.com/";
      }

      const { data } = await $api.medias.getMedia(d);
      this.files = this.files = data.data.map((x) => {
        if (this.fileSrc == "Bandwango" && type == "image") this.scaleDownImage(x);
        return x;
      });
      delete data.data;
      this.pagination = data;
      this.loading.loading = false;
    },
    prepareToDelete(file) {
      Bandwango.helpers('swal', {
        title: 'Are you sure?',
        text: 'Are you sure you want to remove this file?',
        type: 'delete'
      }).then((result) => {
        if (result.value) {
          axios.delete('/medias/' + file.id).then((result) => {
            this.fetchFile(this.activeTab, this.navSearch);
          })
        }
      });
    },
    scaleDownImage(file) {
      if (file.url) {
        if (!file.originalURL)
          file.originalURL = JSON.parse(JSON.stringify(file.url));

        const i = file.url.indexOf("w_300");
        if (i === -1) {
          file.url = file.url.replace("upload/", "upload/w_300/");
        }
      }
    },
    getFiles(type, src = "Bandwango") {
      this.fileSrc = src;
      this.activeTab = type;
      this.files = [];
      this.fetchFile(type);
    },
    resetForm() {
      this.formData = {};
      this.fileName = "";
      this.attachment = "";
      this.searchText = "";
      this.uploadProgress = 0;

    },

    onCloseModal() {
      const modals = document.querySelectorAll('.modal.show');
      if (modals.length)
        document.body.classList.add('modal-open')
    },

    changePage(page) {
      if (page > this.pagination.last_page) {
        page = this.pagination.last_page;
      }
      this.pagination.current_page = page;
      this.fetchFile(this.activeTab);
    },
    selectImage() {
      this.$emit("file-chosen", this.chosenFile);
      $("#media-manager").modal("hide");

      setTimeout(() => {
        window.scrollTo(0, this.$refs.scrollToPoint.getBoundingClientRect().top)
      }, 250);

      setTimeout(() => {
        this.resetForm();
      }, 1000);

    },
    isAdvancedUpload() {
      var div = document.createElement("div");
      return (
          ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
          "FormData" in window &&
          "FileReader" in window
      );
    },
    async getItemData() {
      const [
        productsResponse,
        campaignsResponse,
        venuesResponse,
        dealsResponse,
        packagesResponse
      ] = await Promise.all([
        $api.products.getProducts(),
        $api.campaigns.getCampaigns(),
        $api.venues.getVenues(),
        $api.deals.getDeals(),
        $api.packages.getPackages()
      ]);

      this.products = productsResponse.data;
      this.campaigns = campaignsResponse.data;
      this.venues = venuesResponse.data;
      this.deals = dealsResponse.data;
      this.packages = packagesResponse.data;
    },
    getItemDataOld() {
      const self = this;

      let ajaxCounts = 5;
      // get product names
      $.ajax({
        url:
            utils.apiVersion() +
            (this.superAdmin ? "/superAdmin" : "") +
            "/products?select[]=products.name&select[]=products.id",
        type: "GET",
        dataType: "json",
        success: function (response) {
          self.products = response;

          if (--ajaxCounts === 0)
            self.navChanged(self.navSearch.entity, self.navSearch.itemId);
        },
        error: function (response) {
          self.error_msg = response.message;
        },
      });

      // get campaign names
      $.ajax({
        url:
            utils.apiVersion() +
            (this.superAdmin ? "/superAdmin" : "") +
            "/campaigns?select[]=campaigns.name&select[]=campaigns.id",
        type: "GET",
        dataType: "json",
        success: function (response) {
          self.campaigns = response;

          if (--ajaxCounts === 0)
            self.navChanged(self.navSearch.entity, self.navSearch.itemId);
        },
        error: function (response) {
          self.error_msg = response.message;
        },
      });

      // get venue names
      $.ajax({
        url:
            utils.apiVersion() +
            (this.superAdmin ? "/superAdmin" : "") +
            "/venues?select[]=venues.name&select[]=venues.id",
        type: "GET",
        dataType: "json",
        success: function (response) {
          self.venues = response;

          if (--ajaxCounts === 0)
            self.navChanged(self.navSearch.entity, self.navSearch.itemId);
        },
        error: function (response) {
          self.error_msg = response.message;
        },
      });

      // get deal names
      $.ajax({
        url:
            utils.apiVersion() +
            (this.superAdmin ? "/superAdmin" : "") +
            "/deals?select[]=deals.name&select[]=deals.id",
        type: "GET",
        dataType: "json",
        success: function (response) {
          self.deals = response;

          if (--ajaxCounts === 0)
            self.navChanged(self.navSearch.entity, self.navSearch.itemId);
        },
        error: function (response) {
          self.error_msg = response.message;
        },
      });

      // get packages names
      $.ajax({
        url:
            utils.apiVersion() +
            (this.superAdmin ? "/superAdmin" : "") +
            "/packages?select[]=packages.name&select[]=packages.id",
        type: "GET",
        dataType: "json",
        success: function (response) {
          self.packages = response;

          if (--ajaxCounts === 0)
            self.navChanged(self.navSearch.entity, self.navSearch.itemId);
        },
        error: function (response) {
          self.error_msg = response.message;
        },
      });
    },
  },
  created() {
    this.activeTab = this.showTab;
    //if the user passes down a search then just use that. otherwise give its entity.
    this.navSearch.entity ? this.navSearch.entity : this.entity

    this.fetchFile(this.activeTab, this.navSearch);
  },
  async mounted() {
    const self = this;
    $('#media-manager').on('hidden.bs.modal', function () {
      self.onCloseModal()
    })

    // set up drag and drop
    if (this.isAdvancedUpload()) {
      const vm = this;
      const content = $("#block-content");
      const dropzoneDiv = $("#dropzone");

      content
          .on(
              "drag dragstart dragend dragover dragenter dragleave drop",
              function (e) {
                e.preventDefault();
                e.stopPropagation();
              }
          )
          .on("dragover dragenter", function () {
            $(".dropzone").attr(
                "style",
                "min-height:" + content.height() + "px !important"
            );
            vm.draggingFiles = true;
          });

      dropzoneDiv
          .on(
              "drag dragstart dragend dragover dragenter dragleave drop",
              function (e) {
                e.preventDefault();
                e.stopPropagation();
              }
          )
          .on("dragover dragenter", function () {
            vm.draggingFiles = true;
          })
          .on("dragleave dragend drop", function () {
            vm.draggingFiles = false;
          })
          .on("drop", function (e) {
            vm.addMedia(e.originalEvent.dataTransfer.files);
          });
    }

    // don't do ajax calls if user is not admin
    if (this.isAdmin) {
      await this.getItemData();
      this.navChanged(this.navSearch.entity, this.navSearch.itemId);
    }

  },

  computed: {
    pages() {
      let pages = [];

      let from = this.pagination.current_page - Math.floor(this.offset / 2);

      if (from < 1) {
        from = 1;
      }

      let to = from + this.offset - 1;

      if (to > this.pagination.last_page) {
        to = this.pagination.last_page;
      }

      while (from <= to) {
        pages.push(from);
        from++;
      }

      return pages;
    },
  },
  watch: {
    searchText: function (text) {
      if (text.length > 2) {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
          this.pagination.current_page = 1;
          this.fetchFile(this.activeTab);
        }, 1000);
      }
    },
    success_msg: function (msg) {
      if (msg) {
        One.helpers("notify", {
          align: "center",
          type: "success",
          icon: "fa fa-check mr-1",
          message: msg,
        });
        this.success_msg = "";
      }
    },
    error_msg: function (msg) {
      if (msg) {
        One.helpers("notify", {
          align: "center",
          type: "danger",
          icon: "fa fa-exclamation mr-1",
          message: msg,
        });
        this.error_msg = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.audio {
  overflow: hidden;

  @for $i from 1 through 9 {
    #Line_#{$i} {
      animation: pulse 1s infinite;
      animation-delay: $i * .15s;
    }
  }

  @keyframes pulse {
    0% {
      transform: scaleY(1);
      transform-origin: 50% 50%;
    }

    50% {
      transform: scaleY(.7);
      transform-origin: 50% 50%;
    }

    100% {
      transform: scaleY(1);
      transform-origin: 50% 50%;
    }
  }
}

.mm-modal {
  position: absolute;
  top: -300px;
  height: 800px;
}

.fm-file-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.image > img {
  width: 100%;
}

.file-selected {
  -webkit-box-shadow: 0 0 5px green !important;
  -moz-box-shadow: 0 0 5px green !important;
  box-shadow: 0 0 5px green !important;
}

.dz-message {
  text-align: center;
}

.form-control-clear {
  right: 60px !important;
}

.nav-breadcrumb:before {
  top: 10px !important;
  float: left !important;
}

.card-image > .card-button {
  float: right;
}

.cloudinary_fileupload {
  background: #46c37b;
}

#media-manager {
  background:rgba(0,0,0,0.4);
}
</style>